import React from "react";
import { getZscalerURLParams } from "./../utilities/utilities";
import AttentionMessage from "../components/attention-message";
import Details from "../components/details";
import Disclaimer from "../components/disclaimer";
import Header from "../components/header";
import SafetyNotice from "../safety-notice";
import ServiceNowLink from "../components/servicenow-link";
import ContinueButton from "../components/continue-button";
import config from "../config";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import advanced from "dayjs/plugin/advancedFormat";
// Extend dayjs to add support for timezone and timezone formatting.
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advanced);

const CoachPage = () => {
  let blockMessage = config.blockMessage
    ? config.blockMessage
    : "BLOCKED BY THE END OF THE MONTH";

  const params = getZscalerURLParams();

  if (params.category !== 'Generative AI and ML Applications') {
    return (
      <div className="main fade-up">
        <Header content="Upcoming Change Notice" />
        <AttentionMessage
          content={`Potential violation of the Trinity Health Acceptable Use Policy`}
        />
        <div className="content fade-in">
          <div className="exception-description">
            The website/service you are attempting to access has been identified
            as a potential violation of the Trinity Health Acceptable Use Policy
            and will be blocked as of:
            <p className="blocked-date">{blockMessage}</p>
          </div>
          <div style={{ paddingBottom: "1em" }}>
            In the meantime, you may still access the site by clicking the button
            below:
          </div>
          <div style={{ marginLeft: "1em" }}>
            <ContinueButton />
          </div>
          <div className="support-information">
            <h2>Support Information</h2>
            <p>
              If access to this website/service is required for business purposes
              after this date please provide justification by opening a ticket{" "}
              <ServiceNowLink />
            </p>

            <Details />
          </div>
          <SafetyNotice />
          <Disclaimer />
        </div>
      </div>
    );
  } else {
    return (
      <div className="main fade-up">  
        <Header content="You're Leaving Trinity Health Secure Environment" />

        <div className="content fade-in">
          <div className="exception-description">
            <p>
            Starting July 31, you will no longer be able to access this AI tool that is outside of the Trinity Health secure environment. 
            However, Microsoft Copilot Chat is available as the Trinity Health-supported tool for AI assistance.
            </p>
            <p>
            While we strive to ensure your experience remains safe and productive, please be aware that this external site 
            is not governed by Trinity Health’s security protocols or privacy policies.
            </p>
            <AttentionMessage
              content={`Why Microsoft Copilot Chat`}
            />
            <p>
              <ul>
                <li>Fully integrated with our M365 environment</li>
                <li>Secure and compliant with Trinity Health policies</li>
                <li>Designed to help you work more efficiently</li>
              </ul>
            </p>
            <p>
            Access Microsoft Copilot Chat by clicking the Microsoft 365 Copilot icon in ZENworks or directly through this link:  <a href={config.services.msCopilotUrl} target="_blank">{config.services.msCopilotUrl}</a>
            </p>
            <p>
            By continuing, you acknowledge that you are leaving the Trinity Health secure environment and entering a third-party platform.
            </p>
          </div>
          <div>
            <ContinueButton />
          </div>
          <Details />
          <SafetyNotice />
          <Disclaimer />
        </div>
      </div> 
    );
  }
};

export default CoachPage;
